import { validateBr } from "js-brasil";
import MaskedInput from "react-text-mask";
import { Button, Dimmer, Form, Loader } from "semantic-ui-react";
import useForm from "../../../hooks/useForm";
import { instanceAxiosApiFiliado } from "../../../dataProviders";
import MessageApiErrors from "../../../components/MessageApiErrors";
import { useState } from "react";
import { useNavigate } from "react-router";
import useTempStorage, {
  KEY_COOKIE_CPF_PEDIDO,
  KEY_COOKIE_HASH_PEDIDO,
} from "../../../hooks/useTempStorage";

function FormBusca() {
  const [isLoading, setIsLoading] = useState(false);
  const [erro, setErro] = useState();
  const navigate = useNavigate();
  const { updateCookie: setCpfCookie } = useTempStorage(KEY_COOKIE_CPF_PEDIDO);
  const { deleteCookie: deleteHashCookie } = useTempStorage(
    KEY_COOKIE_HASH_PEDIDO
  );

  const nextWithValidation = () => {
    setIsLoading(true);
    let cpfLimpo = data.cpf.replace(/\D/g, "");
    instanceAxiosApiFiliado
      .post("/public/confirmar-identidade/iniciar", { cpf: cpfLimpo })
      .then(() => {
        setCpfCookie(cpfLimpo);
        deleteHashCookie();
        navigate("/confirmar-identidade");
      })
      .catch(setErro)
      .then(() => setIsLoading(false));
  };

  const validations = {
    cpf: {
      required: {
        value: true,
        message: "Informe seu CPF",
      },
      custom: {
        isValid: (value) => value && validateBr.cpf(value),
        message: "Informe um CPF válido",
      },
      filter: {
        pattern: /\D/g,
      },
    },
  };

  const { data, handleChange, handleSubmit, handleBlur, errors } = useForm(
    validations,
    { cpf: null },
    nextWithValidation
  );

  return (
    <Form>
      {erro && <MessageApiErrors erro={erro} />}
      <Dimmer active={isLoading} inverted>
        <Loader >Aguarde ...</Loader>
      </Dimmer>
      <Form.Group widths="equal">
        <Form.Input
          fluid
          label="Informe seu CPF para continuar"
          required
          error={!!errors.cpf}
        >
          <MaskedInput
            mask={[
              /\d/,
              /\d/,
              /\d/,
              ".",
              /\d/,
              /\d/,
              /\d/,
              ".",
              /\d/,
              /\d/,
              /\d/,
              "-",
              /\d/,
              /\d/,
            ]}
            onBlur={handleBlur}
            onChange={(e) => handleChange("cpf", e.target.value)}
            defaultValue={data.cpf}
            autoFocus
          />
        </Form.Input>
      </Form.Group>
      <a
        style={{ color: "#fff" }}
        className="ui secondary button buttonAcaoMetade"
        href="https://pt.org.br"
      >
        Sair
      </a>
      <Button className="buttonAcaoMetade" onClick={handleSubmit} primary>
        Consultar
      </Button>
    </Form>
  );
}

export default FormBusca;
